module.exports = __webpack_public_path__ + "img/arrow-left-icon.6b6b9480.svg";